export const tipoUsuario = Object.freeze({
    COMPRADOR: 1, 
    FORNECEDOR: 2
}); 